import { PackedAppearance } from '@app/modules/persons/appearances/pack-appearances-into-rows';
import { usePersonLaneIdentity } from '../../hooks/usePersonLaneIdentity';
import { HoverLaneSetter } from '../../shared/apply-lane-hover';
import { getSummaryBarLayout } from '../../shared/persons-track-visual-tokens';
import { AppearanceBar } from '../AppearanceBar';

type PersonsSummaryBarProps = {
  packed: PackedAppearance;
  dimmed: boolean;
  /** True when this bar's person is the active cast/lane hover target. */
  emphasized: boolean;
  onHoverLane: HoverLaneSetter;
};

/**
 * Single appearance interval inside the compact Personas summary strip.
 *
 * Wraps {@link AppearanceBar} with summary-strip height/row offset from packing.
 * Shows one face (solid) or voice (hatched) pill; hover emphasizes that person
 * in the cast cluster and dims other bars.
 */
export function PersonsSummaryBar({
  packed,
  dimmed,
  emphasized,
  onHoverLane,
}: PersonsSummaryBarProps) {
  const { lane, appearance, row } = packed;
  const { isIdentityReady } = usePersonLaneIdentity(lane);

  if (!isIdentityReady) {
    return null;
  }

  const { height, offsetY } = getSummaryBarLayout(row);

  return (
    <AppearanceBar
      lane={lane}
      appearance={appearance}
      height={height}
      offsetY={offsetY}
      dimmed={dimmed}
      emphasized={emphasized}
      onHoverLane={onHoverLane}
    />
  );
}
